import React from 'react';

const COPY: Record<'compliance' | 'llm' | 'asvs', string> = {
  compliance: 'Code-level signals only — use these findings to prepare for a formal audit.',
  llm: 'Heuristic pattern signals, not a certified security audit. Findings may miss real issues or flag safe code.',
  asvs: 'Estimated from automated heuristics — not a substitute for a real OWASP ASVS assessment.',
};

interface Props {
  context: 'compliance' | 'llm' | 'asvs';
}

const HeuristicNotice: React.FC<Props> = ({ context }) => (
  <p className="text-xs text-gray-500">{COPY[context]}</p>
);

export default HeuristicNotice;
